import { render } from "./ProfileScreen.vue?vue&type=template&id=3bffcf4c"
import script from "./ProfileScreen.vue?vue&type=script&lang=js"
export * from "./ProfileScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__